export interface IResearchNavigationMenuItems {
    id: string;
    name: string;
    targetUrl: string;
}

export enum ResearchMenuItems {
    RESEARCH_ID = "researchItem",
    INVESTMENTS_ID = "investmentsItem",
}

export const researchItem: IResearchNavigationMenuItems = {
    id: ResearchMenuItems.RESEARCH_ID,
    name: "Research",
    targetUrl: "/research",
};

export const investmentsItem: IResearchNavigationMenuItems = {
    id: ResearchMenuItems.INVESTMENTS_ID,
    name: "Investments",
    targetUrl: "/investments",
};

export const allResearchItems = [researchItem, investmentsItem];

export const UPDATES_PATHS = ["strategy-updates", "meeting-notes", "flash-reports"];
